export default [
  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
     `@/pages/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
     
      `@/pages/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      
      `@/pages/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      title: 'Login',
      public: true,
    },
    name: 'Login',
    component: () => import(
      
      `@/pages/Login.vue`
    )
  },
  {
    path: '/forgot-password',
    meta: {
      title: 'Forgot Password',
      public: true,
    },
    name: 'ForgotPassword',
    component: () => import(
      
      `@/pages/ForgotPassword.vue`
    )
  },
  {
    path: '/reset-password/:token',
    meta: {
      title: 'Reset Password',
      public: true,
    },
    name: 'ResetPassword',
    component: () => import(
      
      `@/pages/ResetPassword.vue`
    )
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'Dashboard'
    }
  },
  {
    path: '/dashboard',
    meta: { title: 'Dashboard', breadcrumb: true, isCheckPermission:false },
    name: 'Dashboard',
    component: () => import(
      
      `@/pages/Dashboard.vue`
    )
  },
  {
    path: '/autoloader',
    meta: { title: 'AutoLoader', breadcrumb: true },
    name: 'AutoLoader',
    component: () => import(
      
      `@/pages/AutoLoader.vue`
    )
  },
  {
    path: '/profile',
    meta: { title: 'Profile', breadcrumb: true, isCheckPermission:false },
    name: 'PROFILE',
    component: () => import(
      
      `@/pages/Profile.vue`
    )
  },
  {
    path: '/user-profile',
    meta: { title: 'User-Profile', breadcrumb: true, isCheckPermission:false },
    name: 'USERPROFILE',
    component: () => import(
      
      `@/pages/user-profile.vue`
    )
  },
  {
    path: '/resource',
    meta: { title: 'Resource', breadcrumb: true, isCheckPermission:false },
    name: 'resource',
    component: () => import(
      
      `@/pages/Resource.vue`
    )
  },
  {
    path: '/sso',
    meta: { title: 'SSO', breadcrumb: true, isCheckPermission:false },
    name: 'sso',
    component: () => import(
     
      `@/pages/sso.vue`
    )
  },
  {
    path: '/comingsoon',
    meta: { title: 'Comingsoon', breadcrumb: true, isCheckPermission:false },
    name: 'ComingSoon',
    component: () => import(
      
      `@/pages/ComingSoon.vue`
    )
  },
  {
    path: '/privacy-policy',
    meta: { title: 'privacyPolicy', breadcrumb: true, isCheckPermission:false },
    name: 'privacyPolicy',
    component: () => import(
      
      `@/pages/privacyPolicy.vue`
    )
  },
  {
    path: '/advertise',
    meta: { title: 'advertise', breadcrumb: true, isCheckPermission:false },
    name: 'advertise',
    component: () => import(
      
      `@/pages/advertise.vue`
    )
  },
  {
    path: '/terms-conditions',
    meta: { title: 'termsConditions', breadcrumb: true, isCheckPermission:false },
    name: 'termsConditions',
    component: () => import(
      
      `@/pages/termsConditions.vue`
    )
  },
  {
    path: '/faqs',
    meta: { title: 'faqs', breadcrumb: true, isCheckPermission:false },
    name: 'faqs',
    component: () => import(
      
      `@/pages/faqs.vue`
    )
  },
  {
    path: '/tutorials',
    meta: { title: 'tutorials', breadcrumb: true, isCheckPermission:false },
    name: 'tutorials',
    component: () => import(
      
      `@/pages/tutorials.vue`
    )
  },
  {
    path: '/AccessDenied',
    meta: { title: 'AccessDenied', breadcrumb: true, isCheckPermission:false },
    name: 'AccessDenied',
    component: () => import(
     
      `@/pages/AccessDenied.vue`
    )
  },
  {
    path: '/WhatsNext',
    meta: { title: 'WhatsNext', breadcrumb: true, isCheckPermission:false },
    name: 'WhatsNext',
    component: () => import(
      
      `@/pages/WhatsNext.vue`
    )
  },
  {
    path: '/roles/list',
    meta: { title: 'User Profile', breadcrumb: true, isCheckPermission:true, moduleName: 'user_profiles', actionName:'list' },
    name: 'Roles',
    component: () => import(
      
      `@/pages/roles/List.vue`
    )
  },
  {
    path: '/roles/add',
    meta: { title: 'Add User Profile', breadcrumb: true, isCheckPermission:true, moduleName: 'user_profiles', actionName:'add' },
    name: 'AddRole',
    component: () => import(
      
      `@/pages/roles/Add.vue`
    )
  },
  {
    path: '/roles/edit',
    meta: { title: 'Edit User Profile', breadcrumb: true, isCheckPermission:true, moduleName: 'user_profiles', actionName:'edit' },
    name: 'EditRole',
    component: () => import(
      
      `@/pages/roles/Edit.vue`
    )
  },
  {
    path: '/users/list',
    meta: { title: 'Users', breadcrumb: true, isCheckPermission:true, moduleName: 'users', actionName:'list' },
    name: 'Users',
    component: () => import(
      
      `@/pages/users/List.vue`
    )
  },
  {
    path: '/users/imr-users',
    meta: { title: 'Users', breadcrumb: true, isCheckPermission:true, moduleName: 'users', actionName:'list' },
    name: 'ImrUsers',
    component: () => import(
      
      `@/pages/users/ImrUsers.vue`
    )
  },
  {
    path: '/users/add',
    meta: { title: 'Add User', breadcrumb: true, isCheckPermission:true, moduleName: 'users', actionName:'add' },
    name: 'AddUser',
    component: () => import(
      
      `@/pages/users/Add.vue`
    )
  },
  {
    path: '/users/edit/:id',
    meta: { title: 'Edit User', breadcrumb: true, isCheckPermission:true, moduleName: 'users', actionName:'edit' },
    name: 'Edituser',
    component: () => import(
      
      `@/pages/users/Edit.vue`
    )
  },
  {
    path: '/loads/list',
    meta: { title: 'Loads', breadcrumb: true, isCheckPermission:true, moduleName: 'loads', actionName:'list' },
    name: 'Loads',
    component: () => import(
      
      `@/pages/loads/List.vue`
    )
  },
  {
    path: '/loads/add',
    meta: { title: 'Loads', breadcrumb: true, isCheckPermission:true, moduleName: 'loads', actionName:'add' },
    name: 'AddLoad',
    component: () => import(
      
      `@/pages/loads/Add.vue`
    )
  },
  {
    path: '/myloads/detail/:id',
    meta: { title: 'Load Details', breadcrumb: true, isCheckPermission:true, type: 'loads', moduleName: 'loads', actionName:'detail' },
    name: 'LoadDetail',
    component: () => import(
      
      `@/pages/loads/Detail.vue`
    )
  },
  {
    path: '/loadsearch/detail/:id',
    meta: { title: 'Load Details', breadcrumb: true, type: 'search' },
    name: 'SearchLoadDetail',
    component: () => import(
      
      `@/pages/loads/Detail.vue`
    )
  },
  {
    path: '/loads/edit/:id',
    meta: { title: 'Edit Load', breadcrumb: true, isCheckPermission:true, type: 'load', moduleName: 'loads', actionName:'edit' },
    name: 'EditLoad',
    component: () => import(
      
      `@/pages/loads/Edit.vue`
    )
  },
  {
    path: '/loadsearch/edit/:id',
    meta: { title: 'Edit Load', breadcrumb: true, type: 'search' },
    name: 'EditSearchLoad',
    component: () => import(
      
      `@/pages/loads/Edit.vue`
    )
  },
  {
    path: '/loads/search',
    meta: { title: 'Search Loads', breadcrumb: true, isCheckPermission:true, moduleName: 'load_searches', actionName:'list' },
    name: 'SearchLoads',
    component: () => import(
      
      `@/pages/loads/SearchLoads.vue`
    )
  },
  {
    path: '/equipments/add',
    meta: { title: 'Add Equipment Type', breadcrumb: true, isCheckPermission:true, moduleName: 'equipments', actionName:'add' },
    name: 'AddEquipment',
    component: () => import(
      
      `@/pages/equipment/Add.vue`
    )
  },
  {
    path: '/equipments/edit',
    meta: { title: 'Edit Equipment Type', breadcrumb: true, isCheckPermission:true, moduleName: 'equipments', actionName:'edit' },
    name: 'EditEquipment',
    component: () => import(
      
      `@/pages/equipment/Edit.vue`
    )
  },
  {
    path: '/equipments/list',
    meta: { title: 'Equipment Types', breadcrumb: true, isCheckPermission:true, moduleName: 'equipments', actionName:'list' },
    name: 'EquipmentsList',
    component: () => import(
      
      `@/pages/equipment/List.vue`
    )
  },
  {
    path: '/trucks/list',
    meta: { title: 'Trucks', breadcrumb: true, isCheckPermission:true, moduleName: 'trucks', actionName:'list' },
    name: 'Trucks',
    component: () => import(
      
      `@/pages/trucks/List.vue`
    )
  },
  {
    path: '/trucks/add',
    meta: { title: 'Trucks', breadcrumb: true, isCheckPermission:true, moduleName: 'trucks', actionName:'add' },
    name: 'AddTruck',
    component: () => import(
      
      `@/pages/trucks/Add.vue`
    )
  },
  {
    path: '/trucks/detail/:id',
    meta: { title: 'Truck Details', breadcrumb: true, type: 'trucks', isCheckPermission:true, moduleName: 'trucks', actionName:'detail' },
    name: 'TruckDetail',
    component: () => import(
      
      `@/pages/trucks/Detail.vue`
    )
  },
  {
    path: '/trucksearch/detail/:id',
    meta: { title: 'Truck Details', breadcrumb: true, type: 'search' },
    name: 'SearchTruckDetail',
    component: () => import(
      
      `@/pages/trucks/Detail.vue`
    )
  },
  {
    path: '/trucks/edit/:id',
    meta: { title: 'Edit Truck', breadcrumb: true, type: 'truck', isCheckPermission:true, moduleName: 'trucks', actionName:'edit' },
    name: 'EditTruck',
    component: () => import(
      
      `@/pages/trucks/Edit.vue`
    )
  },
  {
    path: '/trucksearch/edit/:id',
    meta: { title: 'Edit Truck', breadcrumb: true, type: 'search' },
    name: 'EditSearchTruck',
    component: () => import(
      
      `@/pages/trucks/Edit.vue`
    )
  },
  {
    path: '/trucks/search',
    meta: { title: 'Search Trucks', breadcrumb: true, isCheckPermission:true, moduleName: 'truck_searches', actionName:'search' },
    name: 'SearchTrucks',
    component: () => import(
      
      `@/pages/trucks/SearchTrucks.vue`
    )
  },
  {
    path: '/loads/fastpost',
    meta: { title: 'FastPost', breadcrumb: true, isCheckPermission:true, moduleName: 'loads', actionName:'add' },
    name: 'FastPost',
    component: () => import(
      
      `@/pages/loads/FastPost.vue`
    )
  },
  {
    path: '/disableduser',
    meta: { title: 'Disabled User', public: true, isCheckPermission:true},
    name: 'DisabledUser',
    component: () => import(
      
      `@/pages/DisabledUser.vue`
    )
  },
  {
    path: '/aggregators/add',
    meta: { title: 'Aggregator', breadcrumb: true, isCheckPermission:false, moduleName: 'aggregators', actionName:'add' },
    name: 'AddAggregator',
    component: () => import(
      
      `@/pages/aggregators/Add.vue`
    )
  },
  {
    path: '/aggregators/list',
    meta: { title: 'Aggregator', breadcrumb: true, isCheckPermission:false, moduleName: 'aggregators', actionName:'list' },
    name: 'AggregatorsList',
    component: () => import(
      
      `@/pages/aggregators/List.vue`
    )
  },
  {
    path: '/send-emails/add',
    meta: { title: 'Emails Broadcast', breadcrumb: true, isCheckPermission:false, moduleName: 'emailbroadcast', actionName:'add' },
    name: 'AddEmailBroadcast',
    component: () => import(
      
      `@/pages/emailbroadcast/Add.vue`
    )
  },
  {
    path: '/trucks/fastpost',
    meta: { title: 'FastPost', breadcrumb: true, isCheckPermission:true, moduleName: 'trucks', actionName:'add' },
    name: 'TruckFastPost',
    component: () => import(
      
      `@/pages/trucks/FastPost.vue`
    )
  },
  {
    path: '/change-password',
    meta: { title: 'Change Password', breadcrumb: true, isCheckPermission:false },
    name: 'ChangePassword',
    component: () => import(
      
      `@/pages/ChangePassword.vue`
    )
  },
  {
    path: '/account',
    meta: { title: 'Account', breadcrumb: true, isCheckPermission:false },
    name: 'ACCOUNT',
    component: () => import(
      
      `@/pages/Account.vue`
    )
  },
  {
    path: '/change-email',
    meta: {
      title: 'Change Email',
      public: true,
    },
    name: 'ChangeEmail',
    component: () => import(
      `@/pages/ChangeEmail.vue`
    )
  },
  {
    path: '/confirm-email',
    meta: {
      title: 'Confirm Email',
      public: true,
    },
    name: 'ConfirmEmail',
    component: () => import(
      `@/pages/ConfirmEmail.vue`
    )
  },
  {
    path: '/documents/list',
    meta: { title: 'Documents', breadcrumb: true, isCheckPermission:false},
    name: 'DocumentsList',
    component: () => import(
      `@/pages/documents/List.vue`
    )
  },
  {
    path: '/imr/list',
    meta: { title: 'IMR', breadcrumb: true, isCheckPermission:false},
    name: 'ImrList',
    component: () => import(
      `@/pages/imr/List.vue`
    )
  },
  {
    path: '/imr/invite',
    meta: { title: 'Invite User', breadcrumb: true, isCheckPermission:false},
    name: 'InviteUser',
    component: () => import(
      `@/pages/imr/invite.vue`
    )
  },
  {
    path: '/mpcodes/list',
    meta: { title: 'MpCodes', breadcrumb: true, isCheckPermission:false},
    name: 'MpCodesList',
    component: () => import(
      `@/pages/mpcodes/List.vue`
    )
  },
  {
    path: '/documents/download-document',
    meta: {
      title: 'Download',
      public: true,
    },
    name: 'Download',
    component: () => import(      
      `@/pages/documents/Download.vue`
    )
  },
  {
    path: '/chatbot/list',
    meta: { title: 'Chatbot', breadcrumb: true, isCheckPermission:false},
    name: 'Chatbot',
    component: () => import(
      `@/pages/chatbot/List.vue`
    )
  },
  {
    path: '/login/imr',
    meta: {
      title: 'Imr Login',
      public: true,
      type: "imr"
    },
    name: 'Login',
    component: () => import(
      `@/pages/Login.vue`
    )
  },
  {
    path: '/forgot-password/imr',
    meta: {
      title: 'Imr Forgot Password',
      public: true,
      type: "imr"
    },
    name: 'ForgotPassword',
    component: () => import(
      `@/pages/ForgotPassword.vue`
    )
  },
  {
    path: '/reset-password/imr/:token',
    meta: {
      title: 'Imr Reset Password',
      public: true,
      type: "imr"
    },
    name: 'ResetPassword',
    component: () => import(
      `@/pages/ResetPassword.vue`
    )
  }
];



// WEBPACK FOOTER //
// ./src/router/paths.js